import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
function PaymentLogoBankPlaceholderAlt(_ref) {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoBankPlaceholderAlt',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 32,
    height: 22,
    viewBox: "0 0 32 22"
  }, props), /*#__PURE__*/React.createElement(Group, {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M0,0 H32 V22 H0z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#87878A",
    d: "M1,11 L13,11 L13,12 L1,12 L1,11 Z M7,0 L14,4 L0,4 L7,0 Z M2,5 L3,5 L3,10 L2,10 L2,5 Z M5,5 L6,5 L6,10 L5,10 L5,5 Z M8,5 L9,5 L9,10 L8,10 L8,5 Z M11,5 L12,5 L12,10 L11,10 L11,5 Z",
    opacity: ".7",
    transform: "translate(9 5)"
  })));
}
PaymentLogoBankPlaceholderAlt.displayName = 'PaymentLogoBankPlaceholderAlt';
export default withProvisionalOverrideFromContext(PaymentLogoBankPlaceholderAlt);
//# sourceMappingURL=index.js.map